const fetchApi = async (route, body, method) => {
  try {
    const headers = {
      "Content-Type": "application/json",
    };

    const response = await fetch(`${route}`, {
      method: method ? method : "get",
      headers,
      body: body && JSON.stringify(body),
    });

    const responseJSON = await response.json();
    console.log("responseJSON", responseJSON);
    return { payload: responseJSON, status: response.status };
  } catch (err) {
    console.log("error in fetch", { route, err });
    return { status: false };
  }
};

export default fetchApi;
